import angular from 'angular'

import Categories                from './categories'
import PurchaseRecord            from './purchase-record'
import UpdateItem                from './update-item'
import CollapasbleInvoices       from './collapsable-invoices'
import Device                    from './device'
import Progressbar               from './progressbar'
import DeviceContent             from './device-content'

let module = angular.module('manage-my-rlink.components', [
  Categories,
  PurchaseRecord,
  CollapasbleInvoices,
  UpdateItem,
  Device,
  Progressbar,
  DeviceContent
])
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/index.js